import React from 'react';
import Button from 'react-bootstrap/esm/Button';
import Card from 'react-bootstrap/esm/Card';
import RedirectPagamentoService from './redirectPagamentoService';
import polliceVerde from './pollice_verde.png';
import polliceRosso from './pollice_rosso.png';
import LoadSpinner from '../../../common/spinner/loadSpinner';


export default class EsitoPagamento extends React.Component{
    constructor(props){
        super(props)
        this.state ={
            load: false,
            dettagliPagamento:{
                esito:false,
                messaggio:"",
                numeroPagamento:"",
                numeroSanzione:"",
                importo:"",
                file:""

            }
        }

        this.redirectPagamentoService = new RedirectPagamentoService();
    }

    componentDidMount(){
        this.getDettagli()


    }

    getDettagli(){
        const params = new URLSearchParams(this.props.location.search);
        const param = params.get("param");
        if(param === null){
            window.location.href = "#/ricercasanzione"
        }else{
            this.redirectPagamentoService.sendEsitoPagamento(param,(result)=>{
                this.setState({dettagliPagamento: result})
                this.setState({load:true})
            },)
        }
    }

    ritornaAllaPaginaDiRicerca(){
        window.location.href = "#/ricercasanzione"
    }

    downloadRicevuta(){
        const element = document.createElement('a')
        element.href = `data:application/pdf;base64,${this.state.dettagliPagamento.file}`
        element.download = `attestato_pagamento_${this.state.dettagliPagamento.numeroSanzione}.pdf`
        document.body.appendChild(element)
        element.click()
    }

    render(){
        return (
            !this.state.load 
            ? <LoadSpinner/>
            :<div style={{paddingBottom:"14vh",paddingTop:"14vh"}}>
                <div className='container-fluid  d-flex justify-content-center align-item-center p-5'>
                <Card className="text-center w-75 ">
                    <Card.Header>{this.state.dettagliPagamento.file !== null ? "Pagamento avvenuto con successo" : "Pagamento non trovato o in errore"}</Card.Header>
                    <Card.Body className='d-flex flex-column justify-content-center align-items-center gap-3'>
                        <Card.Title></Card.Title>
                        {(this.state.dettagliPagamento.file !== null && this.state.dettagliPagamento.file !== "") && <Card.Img style={{width:"5.8rem"}} src={polliceVerde}></Card.Img>}
                        {(this.state.dettagliPagamento.file === null || this.state.dettagliPagamento.file === "" )&&  <Card.Img style={{width:"5.8rem"}} src={polliceRosso}></Card.Img>}
                        <Button variant="primary" onClick={()=>this.ritornaAllaPaginaDiRicerca()}>Ritorna alla pagina di ricerca</Button>
                    </Card.Body>
                    <Card.Footer className="text-muted">
                        {this.state.dettagliPagamento.esito && this.state.dettagliPagamento.file !== ""  && <Button variant='primary' onClick={()=>this.downloadRicevuta()} >Scarica Attestato di Pagamento</Button>}
                    </Card.Footer>
                </Card>
                </div>
            </div>
        )
    }
}
